export default __webpack_public_path__ + "static/media/chevron-left-circle-fill.6d35dc97.svg";